export default __webpack_public_path__ + "static/media/Recruit's Vigor.eb20eb10.jpg";